import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { StringTableService } from '../../services/string-table.service';

@Component({
  selector: 'app-progress-chart',
  templateUrl: './progress-chart.component.html',
  styleUrls: ['./progress-chart.component.scss']
})
export class ProgressChartComponent implements OnInit {

  @ViewChild('pieChart') pieChart: ElementRef;

  @Input() public pieChartData: number[] = [10, 20, 70];

  public pieChartType = 'pie';

  public pieLegend = false;

  bgColor: string[] = [];

  public pieColor: any[];

  public options = {
    tooltips: {
      enabled: false
    },
    hover: { mode: null },
    elements: {
      arc: {
        borderWidth: 0
      }
    }
  };

  constructor(protected stringTableService: StringTableService) { }

  ngOnInit() {
    this.bgColor = this.stringTableService.getArrayOfStrings('progress-chart', 'bgColorArray');
    this.pieColor = [
      {
        backgroundColor: this.bgColor,
        borderColor: this.bgColor
      }
    ];
  }
}



// WEBPACK FOOTER //
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/core/components/progress-chart/progress-chart.component.ts